// extracted by mini-css-extract-plugin
export var avatarContainer = "_en-0";
export var gray = "_en-f";
export var green = "_en-c";
export var icon = "_en-9";
export var image = "_en-1";
export var lg = "_en-6";
export var md = "_en-5";
export var presenceDot = "_en-b";
export var red = "_en-d";
export var sm = "_en-4";
export var status = "_en-a";
export var xl = "_en-7";
export var xs = "_en-3";
export var xxl = "_en-8";
export var xxs = "_en-2";
export var yellow = "_en-e";